(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/hooks.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/hooks.js');
"use strict";


function useBalance() {
  const [balance, setBalance] = React.useState(0);
  React.useEffect(() => {
    let cancelled = false;
    svs.components.account_balance.get(balance => {
      if (!cancelled) {
        setBalance(balance || null);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return balance;
}
svs.tickets_giftshop.hooks = {
  useBalance
};

 })(window);